import {DynField} from '../dyn-field';

export class DynTextAreaField
    extends DynField {

/*    public static createFromObject(object: Object): DynTextAreaField {
        const field = new DynTextAreaField();
        field.updateFormObject(object);
        return field;
    }*/
    constructor() {
        super(null, 'textarea')
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/dyn-text-area-field.ts